// extracted by mini-css-extract-plugin
export default {"header":"CategoryPage_header__PU8iU","gallery":"CategoryPage_gallery__+b+6B","emptyBlock":"CategoryPage_emptyBlock__Q7F9C","items":"CategoryPage_items__I5bZj"};